"use client"
import { usePathname } from 'next/navigation';
import indexOf from 'lodash/indexOf';
import { CART_STEPS } from '@/constants/AppConstants';
import startsWith from 'lodash/startsWith';

export const useCartStep = ()=> {
  const pathname= usePathname()
  let normalizedPathname = pathname.replace(/\/$/, '');

  const pathnameHasLocale = process.env.NEXT_PUBLIC_LOCALES.split(',').some(
    locale => pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`,
  );

  if (pathnameHasLocale) {
    const splitPath = pathname.split('/');
    normalizedPathname = '/' + splitPath.slice(2).join('/');
  }

  return indexOf(CART_STEPS, normalizedPathname)
}
